<script setup lang="ts">
import { inject, ref, type Ref } from 'vue';
import clsx from 'clsx';

const props = defineProps<{ class?: string }>();
const classes = clsx('truncate', props.class);
// Hidden when the sidebar is collapsed to an icon rail (provided by App.vue).
const collapsed = inject<Ref<boolean>>('sidebarCollapsed', ref(false));
</script>

<template>
  <span v-show="!collapsed" :class="classes"><slot /></span>
</template>
